import reducer from './purchaseReducer';
import actions from './purchaseActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
